<script>
import baseMixin from '@/mixins/baseMixin'
import CommentModel from '@/models/comments/commentModel'
import CommentBase from './comment-base.vue'

export default {
  name: 'CommentDefault',
  components: { CommentBase },
  mixins: [baseMixin],
  props: {
    comment: {
      type: CommentModel,
      required: true,
    },
  },
}
</script>

<template>
  <CommentBase
    :added-by="comment.addedBy"
    :text="comment.commentText"
    :subtitle="comment.getDateCreatedTimestamp()"
  />
</template>
